define('helperLayout-appendContent',['helperLayout-createNode'], function(createNode) {
    'use strict';

    var appendContent = function(options) {
        var node = createNode(options),
            containerID = options.containerID || '',
            container = (containerID) ? document.getElementById(containerID) : document.getElementsByTagName('head')[0];

        container = container || document.documentElement;

        if(node) {
            container.appendChild(node);
        }
    };

    return appendContent;
});
